import { useEffect, useRef } from "react";
import { motion } from "framer-motion";
import { Sparkles } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const processed = useRef(false);
  const { setSession } = useAuth();

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const params = new URLSearchParams(window.location.hash.replace("#", ""));
    const sessionId = params.get("session_id");

    (async () => {
      try {
        const { data } = await api.post("/auth/google-session", {}, {
          headers: { "X-Session-ID": sessionId },
        });
        setSession(data.token, data.user);
        if (data.welcome_bonus) {
          toast.success("🎉 Welcome! Your account is ready. Enjoy one extra free AI analysis to start tracking your progress.");
        } else {
          toast.success("Welcome back! 💅");
        }
        window.history.replaceState({}, "", "/dashboard");
        window.location.href = "/dashboard";
      } catch (e) {
        toast.error("Sign-in failed. Please try again.");
        window.location.href = "/";
      }
    })();
  }, [setSession]);

  return (
    <div className="min-h-screen flex items-center justify-center px-4">
      <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }} className="text-center">
        <Sparkles className="w-12 h-12 text-primary mx-auto animate-spin" />
        <p className="mt-4 text-muted-foreground">Signing you in...</p>
      </motion.div>
    </div>
  );
}
